import { getSurveyEditText, getSurveyReOpenedText } from "@teams/cards";
import { TeamsSurveyAppealInfoType } from "@teams/types";

export function getAppId(): string {
  const id = getMetaAttributeContent("og:botid");
  if (!id) {
    throw Error("bot id is not set in meta tag!");
  }
  return id;
}

export function getHelpAppId(): string {
  let id = getMetaAttributeContent("og:bothelpappid");
  if (!id) {
    id = getAppId();
  }
  return id;
}

export function getAuthAppId(): string {
  let id = getMetaAttributeContent("og:botauthappid");
  if (!id) {
    throw Error("bot auth app id is not set in meta tag!");
  }
  return id;
}

export function getStripeKey(): string {
  let id = getMetaAttributeContent("og:stripe_key");
  if (!id) {
    throw Error("stripe key is not set in meta tag!");
  }
  return id;
}

export type PageContext = "/agile" | "/msteams";

export function getPageContext(): PageContext {
  let pageContext = getMetaAttributeContent("og:page_context");
  if (!pageContext) {
    throw new Error("page context is not set in meta tag");
  }
  return pageContext as PageContext;
}

export function getFeatureFlagClientId(): string {
  const id = getMetaAttributeContent("og:ld_id");
  if (!id) {
    throw Error("LaunchDarkly client id is not in meta tag!");
  }
  return id;
}

export function getDataDogEnvironment(): string {
  const env = getMetaAttributeContent("og:dd_environment");
  if (!env) {
    throw Error("DataDog environment is not in meta tag!");
  }
  return env;
}

export function getDataDogApplicationId(): string {
  const id = getMetaAttributeContent("og:dd_application_id");
  if (!id) {
    throw Error("DataDog application id is not in meta tag!");
  }
  return id;
}

export function getDataDogClientToken(): string {
  const token = getMetaAttributeContent("og:dd_client_token");
  if (!token) {
    throw Error("DataDog client token is not in meta tag!");
  }
  return token;
}

export const getIntercomAppId = () => {
  const id = getMetaAttributeContent("og:intercom_id");
  if (!id) {
    throw Error("Intercom id is not in meta tag!");
  }
  return id;
};

function getMetaAttributeContent(key: string): string | null {
  const metaTag = document.querySelector(`meta[property='${key}']`);
  if (metaTag) {
    const content = metaTag.getAttribute("content");
    if (content) {
      return content as string;
    }
  }
  return null;
}

export function capitalizeFirstLetter(str: string | undefined): string | undefined {
  if (!str) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const getEditInfoText = (appealInfo: TeamsSurveyAppealInfoType) => {
  switch (appealInfo) {
    case "reopen":
      return getSurveyReOpenedText();
    case "update":
      return getSurveyEditText(false);
    case "votes-invalidate":
      return getSurveyEditText(true);
  }
};

export const localStorageAvailable = () => {
  const uid = new Date().toISOString();
  localStorageSetItem(uid, uid);
  const result = localStorageGetItem(uid);
  localStorageRemoveItem(uid);
  return result === uid;
};

export const localStorageGetItem = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const localStorageSetItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
};

export const localStorageRemoveItem = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
};
